import Http from '@/api/http.js'

export default {
  createRebill(rebill){
    const {due_date, fee, id} = rebill
    return Http.post(`bills/${id}/duplicate`, {
      duplicate:{
        fee: Number(fee.replace(/,/g, '')),
        due_date
      }
    })

  },

  // BILLS
  indexBill(filter={}){
    return Http.get(`/bills`,{
      params: {
        ...filter
      }
    });
  },
  showBill(id){
    return Http.get(`/bills/${id}`);
  },
  createBill(newBill){
    return Http.post(`/bills`,{
      bill: {
        ...newBill
      }
    })
  },
  createBill2(newBill){
    return Http.post(`/bills`,{
      bill: {
        nf_number:          newBill.nf_number,
        nf_due:             newBill.nf_due,
        value:              newBill.value,
        status_id:          newBill.status_id,
        order_id:           newBill.order_id,
        client_id:          newBill.client_id,
        vrt_transaction_id: newBill.vrt_transaction_id,
        // sent:               newBill.sent,
        // sent_at:            newBill.sent_at,
        // canceled:           newBill.canceled,
        // canceled_at:        newBill.canceled_at,
        // canceled_by_id:     newBill.canceled_by_id,
        // canceled_due:       newBill.canceled_due,
        // concluded_at:       newBill.concluded_at,
        // concluded_by_id:    newBill.concluded_by_id,
        comment:            newBill.comment,
        additional_value:   newBill.additional_value,
      }
    })

  },
  updateBill(upBill){
    return Http.put(`/bills/${upBill.id}`,{
      bill: {
        id:             upBill.id,
        nf_number:          upBill.nf_number,
        our_number:         upBill.our_number,
        company:            upBill.company,
        company_id:         upBill.company_id,
        other_client_cpf_cnpj:  upBill.other_client_cpf_cnpj,
        // nf_due:             upBill.nf_due,
        // value:              upBill.value,
        status_id:          upBill.status_id,
        // order_id:           upBill.order_id,
        // client_id:          upBill.client_id,
        vrt_transaction_id: upBill.vrt_transaction_id,
        sent:               upBill.sent,
        sent_at:            upBill.sent_at,
        canceled:           upBill.canceled,
        canceled_at:        upBill.canceled_at,
        canceled_by_id:     upBill.canceled_by_id,
        canceled_due:       upBill.canceled_due,
        concluded_at:       upBill.concluded_at,
        concluded_by_id:    upBill.concluded_by_id,
        comment:            upBill.comment,

          // 'document_attributes':   upBill.attachment_attributes,

      }
    })

  },
  billOrderDetails(bill_id){
    return Http.get(`/bills/${bill_id}/details`)
  },
  exportBillCsv(params = {}, filter){
    return Http.get('/bills/csv.csv',{
      headers: {
        filter: filter? JSON.stringify(filter) : null
      },
      params: {
        ...params
      }
    })
  },
  exportBillXlsx(params = {}, filter){
    return Http.get('/bills/xlsx.xlsx',{
      headers: {
        filter: filter? JSON.stringify(filter) : null
      },
      params: {
        ...params
      }
    })
  },
  exportBillPDF( params = {}, filter){
    return Http.get('/bills/pdf.pdf',{
      headers: {
        filter: filter? JSON.stringify(filter) : null
      },
      params: {
        ...params
      }
    });
  },
//
}